export default __webpack_public_path__ + "static/media/mozzarella.cb9ca52b.png";